// styles
import styled from 'styled-components';
import SoFormCandidateBlockDetailsInputLabel from './SoFormCandidateBlockDetailsInputLabel';
import moment from 'moment-timezone';
import SoExpressHourPicker from './SoExpressHourPicker';
import { useTranslation } from 'react-i18next';

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;

  width: 276px;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 1;
`;

const SoFormCandidateBlockDetailsInputsExpress = ({ candidate, className }) => {
  const shipment = candidate.formData.quotePayload.shipments[0];
  const pickup_from = shipment.pickup_time_from;
  const dropoff_from = shipment.dropoff_time_from;
  const isDropoffToday = moment(pickup_from).isSame(dropoff_from, 'day');
  const { t } = useTranslation('Catalog');

  return (
    <div className={className}>
      <InputContainer>
        <SoFormCandidateBlockDetailsInputLabel>
          {t('price.express.pickup_today')}
        </SoFormCandidateBlockDetailsInputLabel>
        <SoExpressHourPicker candidate={candidate} isPickup={true} />
      </InputContainer>
      <InputContainer>
        <SoFormCandidateBlockDetailsInputLabel>
          {t('price.express.delivery')}{' '}
          {isDropoffToday
            ? t('price.express.today')
            : t('price.express.tomorrow')}
        </SoFormCandidateBlockDetailsInputLabel>

        <SoExpressHourPicker candidate={candidate} isPickup={false} />
      </InputContainer>
    </div>
  );
};

export default styled(SoFormCandidateBlockDetailsInputsExpress)`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 12px 16px 16px;
  gap: 16px;

  width: 600px;
  height: 100px;

  border-radius: 4px 4px 0px 0px;

  /* Inside auto layout */

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  /* background: pink; */
`;
